
import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Button,
    message,
    Typography,
    Modal
} from "../../ui/ot";
import { OverdueProcessingTable } from "./overdue_processing"
const SpecificUserOverdueModal = ({
    propsIssueCardnumber = null,
    propsOnClose = () => { },
    propsButtonText = "",
}) => {
    const [open, setOpen] = useState(false)

    return <>
        <div
            onClick={() => {
                setOpen(true)
            }}
        >
            <Typography.P
                className="underline text-primary cursor-pointer truncate max-w-[200px]"
            >
                {propsButtonText}
            </Typography.P>
        </div>
        <Modal
            title
            open={open}
            close={true}
            onClose={() => {
                propsOnClose()
                setOpen(false)
            }}
            okText="OK"
            cancelText="Cancel"
            closeText="關閉"
            width={1600}
            confirmLoading={false}
            footer={<>
                <Col>
                    <Button variant="secondary"
                        onClick={() => {
                            setOpen(false)
                        }}
                    >
                        關閉
                    </Button>
                </Col>
            </>}
        >
            <Row gutter={[8, 8]}>
                <Col span={24}>
                </Col>
                <Col span={24}>
                    {open && <OverdueProcessingTable
                        propsIssueCardnumber={propsIssueCardnumber}
                        propsIssueDaysDueStatus="全部"
                        showReturn={true}
                        onChange={() => {
                            propsOnClose()
                        }}
                    />}
                </Col>
            </Row>
        </Modal>
    </>
}
export default SpecificUserOverdueModal